const TWILIO_PHONE_NUMBER_FORMAT_URL =
  'https://www.twilio.com/docs/glossary/what-e164';

const CAMPAIGN_CSV_TEMPLATE_URL =
  'https://popp-ai-storage-prod.s3.eu-west-2.amazonaws.com/Popp+candidate+upload+template+v1.0.csv';

export { TWILIO_PHONE_NUMBER_FORMAT_URL, CAMPAIGN_CSV_TEMPLATE_URL };
